function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStagger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499999 6.3500002",
    id: "svg134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect136",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 0.00052917,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 1.9711127,0.28397387 h 2.80633 V 6.1304948 h -2.80633 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.51
    },
    d: "m 4.309721,0.1503399 v 5.980155 0",
    id: "path965-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.15875,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "0.3175, 0.635",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "m 3.1404169,0.22790231 v 5.84652039 0",
    id: "path965-86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "M 1.1894395,0.65982214 A 0.33408686,0.35914345 0 0 1 0.85535273,1.0189656 0.33408686,0.35914345 0 0 1 0.52126563,0.65982214 0.33408686,0.35914345 0 0 1 0.85535273,0.3006787 0.33408686,0.35914345 0 0 1 1.1894395,0.65982214 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008-3",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "M 5.8165432,3.2114113 A 0.33408686,0.35914345 0 0 1 5.4824564,3.5705547 0.33408686,0.35914345 0 0 1 5.1483693,3.2114113 0.33408686,0.35914345 0 0 1 5.4824564,2.8522679 0.33408686,0.35914345 0 0 1 5.8165432,3.2114113 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008-1",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "M 1.1894395,5.6293651 A 0.33408686,0.35914345 0 0 1 0.85535273,5.9885085 0.33408686,0.35914345 0 0 1 0.52126563,5.6293651 0.33408686,0.35914345 0 0 1 0.85535273,5.2702217 0.33408686,0.35914345 0 0 1 1.1894395,5.6293651 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.51
    },
    d: "m 1.9711127,0.1503399 v 5.9801549 0",
    id: "path965-0-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStagger);
export default __webpack_public_path__ + "static/media/Stagger.8b4c0ec2e32eed07d8f449fb4cf98f15.svg";
export { ForwardRef as ReactComponent };